module.exports = __webpack_public_path__ + "img/bently.876b3ba2.jpg";